import { PluginHeaderActionBlueprint } from '@backstage/frontend-plugin-api';

// Note: to be used in catalog plugin override
export * from './catalog-landing-page';

export const catalogHeaderActions = PluginHeaderActionBlueprint.make({
  params: defineParams =>
    defineParams({
      loader: () => import('./header-actions').then(m => <m.HeaderActions />),
    }),
});
